import {createFileRoute} from '@tanstack/react-router'
import {Button, Container, Grid, LoadingOverlay, Space, Stack, Table, Title} from "@mantine/core";
import {useItemList} from "@state/server/items.query.ts";
import {useCategories} from "@state/server/categories.query.ts";
import {IconInfoCircle} from "@tabler/icons-react";
import ItemEditorModal from "@components/itemEditorModal.tsx";
import {useDisclosure} from "@mantine/hooks";
import {useState} from "react";
import ItemCreation from "@components/itemCreation.tsx";

export const Route = createFileRoute('/_authenticated/items/')({
	component: RouteComponent,
})

function RouteComponent() {
	const {data: items, isLoading: isItemsLoading} = useItemList()
	const {data: categories, isLoading: isCategoriesLoading} = useCategories()
	const [selectedId, setSelectedId] = useState<number>(0)
	const [openItemEditor, {toggle}] = useDisclosure(false)

	const onOpenItemEditor = (id: number) => {
		setSelectedId(id)
		toggle()
	}

	const onCloseItemEditor = () => {
		setSelectedId(0)
		toggle()
	}

	return (
		<Container fluid>
			<LoadingOverlay visible={isItemsLoading || isCategoriesLoading} zIndex={1000}
							overlayProps={{radius: "sm", blur: 2}}/>
			<Title>Položky</Title>
			<ItemEditorModal id={selectedId} opened={openItemEditor} onClose={onCloseItemEditor}/>
			<Grid>
				<Grid.Col span={6}>
					<Stack>
						<ItemCreation addItemCallback={onOpenItemEditor}/>
					</Stack>
				</Grid.Col>
				<Grid.Col span={6}>
					{/*					<Center>
						Tady budou filtry
					</Center>*/}
				</Grid.Col>
			</Grid>
			<Space h={"md"}></Space>
			{(items && categories) && (
				<Table.ScrollContainer minWidth={"md"}>
					<Table>
						<Table.Thead>
							<Table.Tr>
								<Table.Th>#</Table.Th>
								<Table.Th>Název</Table.Th>
								<Table.Th>Druh položky</Table.Th>
								<Table.Th>Akce</Table.Th>
							</Table.Tr>
						</Table.Thead>
						<Table.Tbody>
							{items.map(item => {
								return (
									<Table.Tr key={item.id}>
										<Table.Td>{item.id}</Table.Td>
										<Table.Td>{item.name}</Table.Td>
										<Table.Td
											fs={"italic"}>{categories[item.itemType!] ?? "Neznámý druh"}</Table.Td>
										<Table.Td><Button variant={"subtle"}
														  onClick={() => onOpenItemEditor(item.id)}><IconInfoCircle/></Button></Table.Td>
									</Table.Tr>
								)
							})}
						</Table.Tbody>
					</Table>
				</Table.ScrollContainer>
			)}
		</Container>
	)
}
